define('home/templates/emailVerificationAlert',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"alert alert--warning text-medium\">\n"
    + alias2(helpers.gettext.call(alias1,"The email address for your account %(email)s still needs to be verified.",{"name":"gettext","hash":{"email":helpers.tag.call(alias1,"strong",{"name":"tag","hash":{"text":((stack1 = (depth0 != null ? depth0.user : depth0)) != null ? stack1.email : stack1)},"data":data})},"data":data}))
    + "\n<a href=\"/verify\" data-action=\"verify-email\">"
    + alias2(helpers.gettext.call(alias1,"Resend confirmation email »",{"name":"gettext","hash":{},"data":data}))
    + "</a>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.shouldShowEmailVerificationAlert : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true})

});
